<style lang="stylus" scoped>
@import '../css/var'
.img-container
  display flex
  justify-content space-between
  align-items center
  height pt(130)
  margin-top pt(10)
  margin-bottom pt(10)

.image
  margin-left pt(30)
  width  pt(60)
  margin-right pt(15)

.title
  flex-grow 1

.company-name
  margin-bottom pt(5)

.tip-color
  color #A0A1A3

.code-icon
  color #30C37E
  font-size pt(32)

.qrcode
  width pt(110)
  height pt(110)
  margin-right pt(20)

.bottom-divide
  height  1px
  background #CCD5D8
  margin-left pt(20)
  margin-right pt(20)
</style>
<template>
  <div>
    <div class="img-container">
      <i class="icon code-icon image">&#xe605;</i>
      <div class="title">
        <div class="company-name">关注智慧食堂</div>
        <div class="tip-color">长按右边二维码</div>
      </div>
     <img class="qrcode" :src="qrcode"></img>
  </div>
  <div class="bottom-divide"></div>
  </div>
</template>
<script>
import qrcode from '../assets/img/qrcode.jpg'
export default {
  data () {
    return {
      qrcode: qrcode
    }
  }
}
</script>


// WEBPACK FOOTER //
// attention.vue?b867e670